module.exports = __webpack_public_path__ + "static/media/upload-lg.c8f7f053.svg";